import React from 'react';
import StatCard from '../components/Analytics/StatCard';
import WorldMapChart from '../components/Analytics/WorldMapChart';
import UserTrendChart from '../components/Analytics/UserTrendChart';
import TopCountriesChart from '../components/Analytics/TopCountriesChart';
import SessionMediumChart from '../components/Analytics/SessionMediumChart';
import RealtimeUsersCard from '../components/Analytics/RealtimeUsersCard';
import AnalyticsCard from '../components/Analytics/AnalyticsCard';
import AnalyticsOverview from '../components/Analytics/AnalyticsOverview';
import RealtimeOverview from '../components/Analytics/RealtimeOverview';
import DeviceStats from '../components/Analytics/DeviceStats';
import TrafficSources from '../components/Analytics/TrafficSources';
import './AnalyticsDashboard.css';

const AnalyticsDashboard = () => {
  return (
    <div className="analytics-dashboard">
      {/* Top row: Stats */}
      <div className="grid-row">
        <div className="left-column">
          <AnalyticsOverview />
           <WorldMapChart />
           <SessionMediumChart />
        </div>
        <div className="right-column">
          <RealtimeUsersCard />
          <RealtimeOverview />
           <AnalyticsCard days={7} />
          <AnalyticsCard days={30} />
        </div>
      </div>

      {/* Main middle row: charts and insights */}
      <div className="grid-row main-row">
        <div className="left-column">
          
          <DeviceStats />
        </div>
        <div className="right-column">
          <TrafficSources />
        </div>
      </div>
    </div>
  );
};

export default AnalyticsDashboard;